export class TagsCourrier {
  public canUncheck?: boolean;
  public color: string;
  public statusId?: number;
  public courrierActionDroitDecocherGroupeID: number;
  public creationDate?: string;
  public description?: string;
  public id?: number;
  public mailId?: number;
  public textColor: string;

  constructor(data: Partial<TagsCourrier>) {
    Object.assign(this, data);
  }
}
